/**
 * returnTo — where to send a visitor after sign-in. ProtectedRoute puts the
 * page they asked for (path + query + hash) in /login?returnTo=; LoginPage
 * reads it back through safeReturnTo.
 *
 * Only a same-origin relative path is accepted: it must start with "/", not
 * "//" (protocol-relative), contain no backslash (browsers read "/\" as
 * "//"), and still resolve to this origin once the URL parser has stripped
 * tabs/newlines, and carry no "%2f", "%5c" or "/.." (these can decode or
 * normalise into "//host" downstream). Anything else is an open redirect and returns null.
 */
export function loginPathFor(returnTo: string): string {
    return `/login?${new URLSearchParams({ returnTo })}`;
}

export function safeReturnTo(value: string | null | undefined): string | null {
    if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return null;
    // Encoded slashes/backslashes and dot-segments can be decoded or
    // normalised into "//host" later (router, proxy); no real route needs them.
    if (/%2f|%5c|\/\.\./i.test(value)) return null;
    try {
        const origin = window.location.origin;
        return new URL(value, origin).origin === origin ? value : null;
    } catch {
        return null;
    }
}
